import React from "react";

export default function Sixteen({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M64.6,264.36h1.3a.84.84,0,0,1,.84.84v16.37H71.8v-8.92a.83.83,0,0,1,.84-.84H86.11a.84.84,0,0,1,.84.84v8.92H92V265.2a.87.87,0,0,1,.24-.59.83.83,0,0,1,.59-.25h1.31L79.39,251.48Z" />
      <path d="M149.7,275.68c0,2.63,2.37,3.76,4.53,3.76,3.65,0,5.66-3.36,5.66-3.36v-2.81a9.78,9.78,0,0,0-5.3-1.39C152.4,271.88,149.7,273.05,149.7,275.68Z" />
      <path d="M249.18,236.46H50.82a9.7,9.7,0,0,0-9.7,9.7v43.56a9.7,9.7,0,0,0,9.7,9.7H249.26a9.63,9.63,0,0,0,9.62-9.7V246.16A9.7,9.7,0,0,0,249.18,236.46Zm-152,29a.85.85,0,0,1-.78.54H93.68v16.37a.84.84,0,0,1-.84.84H86.11a.85.85,0,0,1-.84-.84v-8.93H73.47v8.93a.84.84,0,0,1-.83.84H65.9a.85.85,0,0,1-.84-.84V266H62.37a.83.83,0,0,1-.55-1.47l17-14.82a.85.85,0,0,1,1.1,0l17,14.83A.85.85,0,0,1,97.17,265.5Z" />
      {children}
    </svg>
  );
}
